import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';

import { GroupByOptionToFriendlyNameMap, itemGroupByOptions } from './constants';

/**
 * @typedef {import('../../../../ui-components/components/button/button-types.d.ts').ButtonThemeValues} ButtomTheme
 */

/**
 * @typedef {import('./items-section-types.d.ts').GroupByOption} GroupByOption
 */

/**
 * @param {object} props
 * @param {GroupByOption} props.selectedOption
 * @param {(option: GroupByOption) => void} props.onOptionSelected
 * @param {ButtomTheme} props.theme
 * @param {string} props.dropdownTogglerClassName
 * @returns {JSX.Element}
 */
export const GroupByDropdown = ({ selectedOption, onOptionSelected, theme = 'link', dropdownTogglerClassName }) => {
  const selectedOptionName = GroupByOptionToFriendlyNameMap[selectedOption];

  return (
    <DropdownMenu dropdownMenuType={DropdownMenuType.ComboBox} menuPosition={DropdownMenuPosition.BottomRight}>
      <DropdownMenuToggler className={dropdownTogglerClassName} theme={theme}>
        {selectedOptionName}
      </DropdownMenuToggler>
      {itemGroupByOptions.map((option) => {
        return (
          <DropdownMenuItem key={option} onClick={() => onOptionSelected(option)} selected={option === selectedOption}>
            {GroupByOptionToFriendlyNameMap[option]}
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
};
